/* unplugin-vue-components disabled */import { render } from "./three_chose_one.vue?vue&type=template&id=f4b568e4&scoped=true"
import script from "./three_chose_one.vue?vue&type=script&lang=js"
export * from "./three_chose_one.vue?vue&type=script&lang=js"

import "./three_chose_one.vue?vue&type=style&index=0&id=f4b568e4&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b568e4"]])

export default __exports__